export default "__VITE_ASSET__BqVsB57E__"